import { render } from "./TimeRange.vue?vue&type=template&id=1f79f80d"
import script from "./TimeRange.vue?vue&type=script&lang=js"
export * from "./TimeRange.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__